import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import {PriorityImg} from "../components/PriorityImg";
import React from "react";

const backgroundImage = '/img/factory_back.jpg'

export default function ProductHero() {

  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#434445', // Average color of the background image.
        backgroundPosition: 'center',
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <PriorityImg
        style={{ display: 'none' }}
        src={backgroundImage}
        alt="component parts"
        fetchpriority="high"
      />
      <Typography color="inherit" backgroundColor={'primary.dark'} align="center" variant="h2" marked="center" sx={{p:1.25}}>
        we turn raw materials into components
      </Typography>
        <Typography color="inherit" backgroundColor={'primary.dark'} align="center" variant="h5" marked="center" sx={{p:1.25}}>
            We are the demo company for GovSky.
        </Typography>
    </ProductHeroLayout>
  );
}
